import React from 'react';
import { useStepProcessor } from '../../context/StepProcessorContext';

const AuthStepProcessor: React.FC = () => {
  const { steps, currentStepIndex } = useStepProcessor();
  const currentStep = steps[currentStepIndex];

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 bg-white shadow-sm">
        <h1 className="text-xl font-semibold text-center text-customBlue">Authentication</h1>
        <div className="flex justify-center mt-4">
          {steps.map((step, index) => (
            <div key={step.id} className="flex items-center">
              <div 
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  step.isActive 
                    ? 'bg-customBlue text-white' 
                    : step.isCompleted 
                      ? 'bg-green-500 text-white' 
                      : 'bg-gray-200 text-gray-600'
                }`}
              >
                {step.isCompleted ? (
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              {index < steps.length - 1 && (
                <div className={`h-1 w-10 ${
                  steps[index + 1].isActive || step.isCompleted ? 'bg-customBlue' : 'bg-gray-200'
                }`} />
              )}
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex-grow p-4">
        {currentStep?.component}
      </div>
    </div>
  );
};

export default AuthStepProcessor;
